import { render, staticRenderFns } from "./CustomActivator.vue?vue&type=template&id=2faf8aca"
import script from "./CustomActivator.vue?vue&type=script&lang=js"
export * from "./CustomActivator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports